import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles/utils/fill";
export const OptimismLogo = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      fill: t1,
      fillAttribute: t2,
      size: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const fill = t1 === undefined ? "current" : t1;
  const fillAttribute = t2 === undefined ? "currentColor" : t2;
  const size = t3 === undefined ? 24 : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M4.738 18.311c-1.392 0-2.532-.327-3.42-.981C.439 16.666 0 15.713 0 14.489c0-.262.028-.57.084-.944.15-.841.365-1.85.645-3.038.794-3.215 2.85-4.822 6.159-4.822.897 0 1.71.15 2.42.458.71.29 1.271.738 1.683 1.336.41.59.616 1.29.616 2.103 0 .243-.028.552-.084.925a37.925 37.925 0 0 1-.635 3.038c-.411 1.598-1.112 2.804-2.122 3.598-1 .785-2.345 1.168-4.028 1.168Zm.253-2.523c.654 0 1.205-.196 1.663-.58.467-.383.804-.972 1-1.775.271-1.103.477-2.056.617-2.879.047-.243.075-.495.075-.757 0-1.065-.552-1.598-1.664-1.598-.654 0-1.215.196-1.682.58-.458.383-.785.971-.981 1.775-.215.785-.42 1.738-.636 2.879a3.73 3.73 0 0 0-.075.738c-.009 1.084.561 1.617 1.683 1.617Zm7.43 2.355c-.131 0-.225-.037-.3-.122-.056-.093-.074-.196-.056-.317l2.421-11.402a.466.466 0 0 1 .196-.318.515.515 0 0 1 .337-.121h4.663c1.3 0 2.337.27 3.122.803C23.598 7.208 24 7.984 24 9.003c0 .29-.037.598-.103.916-.29 1.345-.878 2.336-1.776 2.981-.878.645-2.084.963-3.616.963H16.14l-.804 3.84a.502.502 0 0 1-.196.318.515.515 0 0 1-.336.122H12.42Zm6.205-6.701c.495 0 .916-.13 1.28-.402.374-.27.617-.654.739-1.159a2.86 2.86 0 0 0 .056-.523c0-.337-.103-.598-.3-.776-.195-.187-.541-.28-1.018-.28H17.28l-.663 3.14h2.01Z" fill={fillAttribute} />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};